import React, { useContext } from "react";
import { T } from "../../hooks/useTranslate";
import { useParams, useLocation } from "react-router-dom";
import { Stack, Typography } from "@mui/material";
import { PartnersContext } from "../../hooks/PartnersContext";
import { useAuth } from "../../hooks/useAuth";
import { PartnersMonthSelect } from "./PartnersMonthSelect";
import { PartnersSearchResultsTitle } from "../PartnersSearchResultsScreen/PartnersSearchResultsTitle";
import { PartnersSearchSortButtons } from "./PartnersSearchSortButtons";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const PartnersHeadSection = ({ isWebView }) => {
  const { contextUserFirstName, loading } = useContext(PartnersContext);
  const { distributorId } = useParams();
  const { userInfo } = useAuth();
  const location = useLocation();

  const theme = useTheme();
  const viewportIsMedium = useMediaQuery(theme.breakpoints.up("md"));

  const title = location.pathname === "/partners" ? <T>my_frontline</T> :
    distributorId === undefined ? ""
      : loading ? ""
        : distributorId === userInfo.unicityId.toString() ? <T>my_frontline</T>
          : <>{`${contextUserFirstName}'s `}<T>frontline</T></>

  return (
    <Stack id="partners-data-grid-head-section">
      <Stack>
        <Stack
          justifyContent="space-between"
          alignItems={viewportIsMedium ? "center" : null}
          data-test-id={`partners-datagrid-title`}
          direction={viewportIsMedium ? "row" : "column"}
          gap={2}
          p={3}
        >
          <Typography sx={{ minWidth: "155px" }} variant="h2">{title && title}</Typography>
          {location.pathname.includes("/partners/search-results") && !loading && <PartnersSearchResultsTitle />}
          {isWebView ? <PartnersMonthSelect isDashboard={false} isWebView={isWebView} /> : null}
          <PartnersSearchSortButtons />
        </Stack>
      </Stack>
    </Stack>
  );
};

export { PartnersHeadSection };
